import axios from 'axios';
import defaultAxiosClient from 'utils/axios';

class AxiosClientWrapper {
    constructor(baseURL) {
        this.axiosInstance = axios.create({
            baseURL,
            validateStatus: (status) => status >= 200 && status < 400
        });
    }

    static urlParamsMaker(baseUrl, params) {
        const totalParams = params.length;
        const isValidArray = Array.isArray(params) && totalParams > 0;

        if (isValidArray) {
            return params.reduce((prev, curr, idx) => {
                const [key, value] = curr;
                if (!key || (!value && typeof value !== 'number')) return prev;

                prev += idx === 0 ? `?${key}=${value}` : `&${key}=${value}`;
                return prev;
            }, baseUrl);
        }

        return baseUrl;
    }

    setAuthorizationHeaders(token) {
        this.axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    setSingleHeader(key, value) {
        this.axiosInstance.defaults.headers.common[key] = value;
    }

    setMultipleHeaders(params) {
        // sample params [[key,value],[key,value]]
        if (Array.isArray(params) && params.length > 0) {
            params.forEach(([key, value]) => {
                this.axiosInstance.defaults.headers.common[key] = value;
            });
        }
    }

    async request(method, url, data = null, customConfig = {}) {
        let responseData;
        let status;
        const errMessage = '';
        const hasErr = false;

        const config = {
            method,
            url,
            ...customConfig,
            headers: {
                ...defaultAxiosClient.defaults.headers.common,
                ...(customConfig.headers || { source: 'mweb' })
            }
        };
        if (data) config.data = data;

        const response = await this.axiosInstance.request(config);

        return response;
    }

    get(url, customConfig = {}) {
        return this.request('get', url, null, customConfig);
    }

    post(url, data = {}, customConfig = {}) {
        return this.request('post', url, data, customConfig);
    }

    put(url, data = {}, customConfig = {}) {
        return this.request('put', url, data, customConfig);
    }

    patch(url, data = {}, customConfig = {}) {
        return this.request('patch', url, data, customConfig);
    }

    delete(url, customConfig = {}) {
        return this.request('delete', url, null, customConfig);
    }
}

export default AxiosClientWrapper;
